module.exports = __webpack_public_path__ + "assets/img/D1.13ba0967.jpg";